// let httpUser = `http://boxuser-dev.dhsf.xqhuyu.com` // 用户
// let httpContent = `http://pc-content-dev.dhsf.xqhuyu.com` // 内容
// let httpLiveBroad = `http://live-dev.996box.com`  // 直播
// let httpCompetition = `http://boxmanagerht-api-dev.dhsf.xqhuyu.com/uploads`  // 赛事
// ------------------正式----------------------
// let httpUser = `https://user-api.996box.com` // 用户
// let httpContent = `https://pc-api.996box.com` // 内容
// let httpLiveBroad = `https://live-api.996box.com`  // 直播
// let httpCompetition = `https://tgdata.996box.com` // 内容

let httpUser = process.env.VUE_APP_USER_BASE_URL; // 用户
let httpContent = process.env.VUE_APP_PC_BASE_URL; // 内容
let httpLiveBroad = process.env.VUE_APP_LIVE_BASE_URL; // 直播
let httpCompetition = process.env.VUE_APP_BOXMANAGE_BASE_URL; // 内容
let baiduApi = `//pc-api.996box.com/v2/homeapi/Ocpcapi/index`

const firstVersoin = `/v1`; // 第一版
const secondVersoin = `/v2`; // 第一版
const homeUrl = `/homeapi`; // 首页
const OperationUrl = `/Operation`; // 埋点
let liveBroadApi = `/api`;
// 是否为开发环境
if (process.env.NODE_ENV === "development") {
  httpUser = ``; // 用户
  httpContent = ``; // 内容
  httpLiveBroad = ``;
  liveBroadApi = `/liveApi`;
  httpCompetition = `/uploads`;
  baiduApi = `http://pc-content-dev.dhsf.xqhuyu.com/v2/homeapi/Ocpcapi/index`;
}
export default {
  homes: {
    // 获取下载链接
    getGameLink: `https://tgdata.996box.com/down_url.json`,
    // 获取盒子下载链接
    getDownUrl: `${httpUser}${firstVersoin}/ChannelDownLink/getDownUrl`,
    // 获取QQ一键加群KEY
    getQQKey: `${httpContent}${firstVersoin}${homeUrl}/Homeindex/randomQqQunKey`,
    // 顶部轮播和排行版
    homeList: `${httpContent}${firstVersoin}${homeUrl}/homeindex/info`,
    // 新闻列表
    getNewsList: `${httpContent}${firstVersoin}${homeUrl}/Homeindex/getNewsList`,
    // 获取新闻详情
    getNewsInfo: `${httpContent}${firstVersoin}${homeUrl}/Homeindex/getNewsInfo`,
    // 游戏详情
    gameInfo: `${httpContent}${firstVersoin}${homeUrl}/gameindex/gameInfo`,
    // 同厂推荐
    firmRecommend: `${httpContent}${firstVersoin}${homeUrl}/gameindex/firmRecommend`,
    // 新游推荐
    newGameList: `${httpContent}${firstVersoin}${homeUrl}/Gameindex/NewGameList`,
    // 版本与标签接口
    tagList: `${httpContent}${firstVersoin}${homeUrl}/FindGame/getAllVersionAndTagList`,
    // 版本与标签接口
    getAllVersionAndTagList: `${httpContent}/v2/homeapi/ShunWan/getAllVersionAndTagList`,
    // shunwan渠道开服列表
    getListShunWan: `${httpContent}/v2/homeapi/ShunWan/getList`,
    // 时间段配置获取
    getTimeSection: `${httpContent}/v2/homeapi/ShunWan/getTimeSection`,
  },
  // 埋点
  operation: {
    // 操作记录
    record: `${httpUser}${firstVersoin}${OperationUrl}/record`,
    // 用户行为记录
    footprint: `${httpUser}${firstVersoin}${OperationUrl}/footprint`,
  },
  // 直播
  live: {
    // 禁言用户列表
    muteUserList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/muteUserList`,
    // 查询用户
    searchUser: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/searchUser`,
    // 解除禁言记录列表
    unlockMuteList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/unlockMuteList`,
    // 解除禁言
    unlockMute: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/unlockMute`,
    // 禁言观众/添加
    muteUser: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/muteUser`,
    // 屏蔽词列表
    blackWordsList: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/blackWordsList`,
    // 删除屏蔽词
    delBlackWord: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/delBlackWord`,
    // 添加直播间屏蔽词
    addBlackWord: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/addBlackWord`,
    // 收礼列表
    receivedGiftList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/Gift/receivedGiftList`,
    // 关注/取关
    doFollow: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/doFollow`,
    // 直播列表
    liveList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/live/liveList`,
  },
  liveBroadRoom: {
    // 推荐直播
    recommendLiveList: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/recommendLiveList`,
    // 获取拉流地址
    getPullUrl: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/getPullUrl`,
    // 直播列表
    liveList: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/liveList`,
    // 礼物列表
    giftList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/Gift/giftList`,
    //  主播中心设置
    anchorCenter: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/User/anchorCenter`,
    //  主播中心设置保存
    anchorCenterSave: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/User/anchorCenterSave`,
    //  开始直播
    beginLive: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/beginLive`,
    //  结束直播
    endLive: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/endLive`,
    //  直播记录
    liveRecord: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/liveRecord`,
    //  获取推流地址（CDN推拉流）
    getPushKey: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/getPushKey`,
    //  直播间详情
    liveDetail: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/liveDetail`,
    //  观众进入直播间
    enterLiveRoom: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/enterLiveRoom`,
    //  文本消息-发送文本消息
    sendTextMessage: `http://live-dev.996box.com/api/v2/Message/sendTextMessage`,
    //  赠送礼物
    giveGift: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/Gift/give`,
    //  关闭推流地址显示(CDN推拉流)
    closePushUrl: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/closePushUrl`,
    // 关注列表
    followList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/followList`,
    //  结束界面直播推荐(CDN推拉流)
    recommendLive: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/recommendLive`,
    //  主播中心标题保存
    anchorCenterSaveTitle: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/User/anchorCenterSaveTitle`,
  },
  // 赛事
  competition: {
    //  赛程预告
    competition_time: `${httpCompetition}/competition/competition_time.json`,
    //  参赛资格
    config: `${httpCompetition}/competition/config.json`,
    //  参赛介绍
    family: `${httpCompetition}/competition/family.json`,
    //  小组赛
    group: `${httpCompetition}/competition/group.json`,
    //  淘汰赛
    eliminate: `${httpCompetition}/competition/eliminate.json`,
    //  排名
    rank: `${httpCompetition}/competition/rank.json`,
  },
  sw: {
    uploadConvertData: baiduApi,
  },
};
